module.exports = __webpack_public_path__ + "img/2.790e456a.jpg";